import styled from 'styled-components';
import { BodySmallMedium } from '@src/fonts/typography/Typography';

export const chipColorMap = {
  primary: {
    backgroundColor: '#e1f2ff',
    borderColor: '#b8deff',
    textColor: '#0a5afa',
  },
  neutral: {
    backgroundColor: '#E8E8E8',
    borderColor: '#D2D2D2',
    textColor: '##333333',
  },
  success: {
    backgroundColor: '#E6F6E5',
    borderColor: '#C3E8C0',
    textColor: '#006400',
  },
};

export const StyledChip = styled.div<{ color: keyof typeof chipColorMap }>`
  display: flex;
  justify-content: center;
  align-items: center;

  background-color: ${(props) => chipColorMap[props.color].backgroundColor};
  border-radius: 99999px;
  padding: 2px 10px;
  border: 1px solid ${(props) => chipColorMap[props.color].borderColor};

  strong {
    ${BodySmallMedium};
    color: ${(props) => chipColorMap[props.color].textColor};
    font-weight: 500;
    display: flex;
    align-items: center;
    gap: 4px;

    svg {
      flex-shrink: 0;
      color: ${(props) => chipColorMap[props.color].textColor};
    }
  }
`;
